import React from 'react';
const About = () => {
  return <section id="meist" className="py-16 bg-gray-50" data-id="element-11">
      <div className="container mx-auto px-4" data-id="element-12">
        <div className="flex flex-col md:flex-row items-center" data-id="element-13">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8" data-id="element-14">
            <img src="https://images.unsplash.com/photo-1581338834647-b0fb40704e21?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="Mööbli paigaldus" className="rounded-lg shadow-md w-full h-auto" data-id="element-15" />
          </div>
          <div className="md:w-1/2" data-id="element-16">
            <h2 className="text-3xl font-bold mb-6 text-gray-900" data-id="element-17">Meist</h2>
            <p className="text-gray-700 mb-4" data-id="element-18">
              Bivek Mööblipaigaldus on spetsialiseerunud kvaliteetsele mööbli
              montaažile ja paigaldusele. Meie eesmärk on pakkuda klientidele
              usaldusväärset ja professionaalset teenust, mis vastab kõigile
              ootustele.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-19">
              Oleme tegutsenud mööblipaigalduse valdkonnas aastaid ning omame
              kogemusi erinevat tüüpi mööbli kokkupanekul ja paigaldusel. Meie
              töö on alati hoolikas ja täpne.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-20">
              Peame oluliseks ausust, täpsust ja kvaliteeti. Meie kliendid
              hindavad meie töö puhtust ja professionaalsust.
            </p>
            <div className="mt-6 bg-white p-4 rounded-lg shadow-sm" data-id="element-21">
              <h3 className="text-xl font-semibold mb-2 text-blue-900" data-id="element-22">
                Miks valida meid?
              </h3>
              <ul className="list-disc pl-5 text-gray-700" data-id="element-23">
                <li data-id="element-24">Professionaalne ja kiire teenindus</li>
                <li data-id="element-25">Kogemused erinevate mööblitüüpidega</li>
                <li data-id="element-26">Konkurentsivõimeline hind</li>
                <li data-id="element-27">Paindlik ajagraafik</li>
                <li data-id="element-28">Teenindame kogu Eestit</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default About;